export const civilities = ["Monsieur", "Madame"] as const
export type civilityType = typeof civilities[number]

export type RepresentativeType = {
    civility: civilityType,
    lastName: string,
    firstName: string
}